import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import DescriptionTable from '../RoundSpecialsMatchTimeline/DescriptionTable';
import LeftHeadersTable from './LeftHeaderTable';
import RightOddsDetailTable from './RightOddsDetailTable';
import { aExportRoundSpecialOddsDetailsAction, aGetRoundSpecialOddsDetailsAction } from '../../reducers/roundSpecials';
import { getRoundSpecialDetails, getRoundSpecialDisplayedMarketOdds, getRoundSpecialOddsDetails, getRoundSpecialOddsHistoryTemplate, getRoundSpecialSelectedMarketHistoryOdds } from '../../selectors/roundSpecials';
import { ODDS_HISTORY_MARKET_EXCEPTIONS, PAGES } from '../../constants';
import { getLeaguesMemoized, getMarkets, getTimezone } from '../../selectors/common';

const RoundSpecialsOddsHistoryStep2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const roundSpecialDetails = useSelector(getRoundSpecialDetails);
  const allMarkets = useSelector(getMarkets);
  const selectedMarketIdsInStore = useSelector(getRoundSpecialSelectedMarketHistoryOdds);
  const oddsHistoryTemplateInStore = useSelector(getRoundSpecialOddsHistoryTemplate);
  const marketsDisplayedInStore = useSelector(getRoundSpecialDisplayedMarketOdds);
  const oddsDetails = useSelector(getRoundSpecialOddsDetails);
  const timezone = useSelector(getTimezone);
  const leagues = useSelector(getLeaguesMemoized);
  const selectedLeague = leagues.find((league) => league.id === roundSpecialDetails?.leagueId);

  function exportToExcel() {
    dispatch(aExportRoundSpecialOddsDetailsAction({ roundId: roundSpecialDetails?.roundId, markets: selectedMarketIdsInStore}));
  }

  function getMarketIds(selectedMarketIds, displayedMarketIds, oddsHistoryTemplate) {
    return selectedMarketIds.reduce((markets, currentMarketId) => {
      const marketDetails = oddsHistoryTemplate.find((market) => market.id === currentMarketId);
      const marketIds = marketDetails?.marketIds || [];
    
      if (ODDS_HISTORY_MARKET_EXCEPTIONS?.includes(currentMarketId)) {
        marketIds.forEach((id) => {
          if (displayedMarketIds?.includes(id?.toString())) {
            markets.push(id);
          }
        });
      } else if (marketDetails?.useMainMarketId) {
        if (marketIds[0]) markets.push(marketIds[0]);
      } else {
        markets.push(...marketIds);
      }
      return markets;
    }, []);
  }

  useEffect(function loadOddsDetails() {
    if (!roundSpecialDetails?.roundId) {
      navigate(`${PAGES.ROUND_SPECIALS_ODDS_HISTORY_STEP_1}/${params.id}`);
    } else if (params?.id) {
      dispatch(aGetRoundSpecialOddsDetailsAction({ id: params.id }));
    }
  }, [dispatch, navigate, params?.id, roundSpecialDetails?.roundId]);

  const marketIds = getMarketIds(selectedMarketIdsInStore, marketsDisplayedInStore, oddsHistoryTemplateInStore);
  const selectedMarkets = marketIds.map((marketId) => allMarkets.find((market) => market.id === parseInt(marketId)));

  return (
    <div>
      <DescriptionTable roundId={roundSpecialDetails?.roundId} publicRoundId={roundSpecialDetails?.roundPublicId} leagueName={selectedLeague?.name} seasonId={roundSpecialDetails?.seasonId} />
      <div className="odds m-t-30">
        <LeftHeadersTable onExportToExcel={exportToExcel} oddsDetails={oddsDetails} timezone={timezone} />
        <RightOddsDetailTable selectedMarkets={selectedMarkets} oddsDetail={oddsDetails} />
      </div>
    </div>
  );
};

export default RoundSpecialsOddsHistoryStep2;